export default __webpack_public_path__ + "static/media/jaslok_bg.d89fcfe8.jpeg";